import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box, styled, useTheme } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import useResponsive from 'src/hooks/useResponsive';
import { useStores } from 'src/models';
import { HEADER } from 'src/static/constants';

import Header from './header/Header';
import MainHeader, { HeaderInfo } from './header/MainHeader';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import Main from './Main';

export type DashboardLayoutContext = {
  setCustomHeader: React.Dispatch<React.SetStateAction<HeaderInfo | undefined>>;
  scrollRef: React.RefObject<HTMLDivElement>;
};

export default function DashboardLayout() {
  const theme = useTheme();
  const { commonCodeStore } = useStores();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { themeLayout } = useSettingsContext();
  const isDesktop = useResponsive('up', 'lg');
  const isNavMini = themeLayout === 'mini';
  const [open, setOpen] = useState(false);
  const [customHeader, setCustomHeader] = useState<HeaderInfo | undefined>(undefined);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    commonCodeStore.getCommonCodes();
    commonCodeStore.getDynamicCodes();
  }, []);

  return (
    <LayoutContainer>
      <ContentsContainer>
        {/* lg 이하일 떄 햄버거 메뉴 header */}
        <Header onOpenNav={handleOpen} />
        <Box sx={{ backgroundColor: theme.palette.navBackgrounColor }}>
          {isDesktop && isNavMini ? (
            <NavMini />
          ) : (
            <NavVertical openNav={open} onCloseNav={handleClose} />
          )}
        </Box>

        <MainContainer id="dashboard-container">
          <MainHeader customHeader={customHeader} />
          <Main scrollRef={scrollRef}>
            <Outlet
              context={{
                setCustomHeader,
                scrollRef,
              }}
            />
          </Main>
        </MainContainer>
      </ContentsContainer>
    </LayoutContainer>
  );
}
const LayoutContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
}));

const ContentsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  marginTop: `${HEADER.H_DASHBOARD_TOP_HEADER_MOBILE}px`,
  height: '100%',
  [theme.breakpoints.up('lg')]: {
    marginTop: `${HEADER.H_DASHBOARD_TOP_RIGHT_HEADER_DESKTOP}px`,
  },
}));

const MainContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  flexGrow: 1,
  overflow: 'hidden',
  height: `calc(100% - ${HEADER.H_DASHBOARD_SCREEN_HEADER_MOBILE}px)`,
  [theme.breakpoints.up('lg')]: {
    marginTop: HEADER.H_DASHBOARD_TOP_LEFT_HEADER_DESKTOP,
  },
}));
